import { render, staticRenderFns } from "./View-ponto-atendimento.vue?vue&type=template&id=60fae2a8&"
import script from "./View-ponto-atendimento.vue?vue&type=script&lang=js&"
export * from "./View-ponto-atendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports